import { render, staticRenderFns } from "./TeacherPolicyForm.vue?vue&type=template&id=7a7cf876&scoped=true"
import script from "./TeacherPolicyForm.vue?vue&type=script&lang=js"
export * from "./TeacherPolicyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7cf876",
  null
  
)

export default component.exports